import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getReadingHistory } from '../services/readingService';
import '../styles/HistoryPage.css';

const HistoryPage = () => {
  const [readings, setReadings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReadingHistory = async () => {
      try {
        const data = await getReadingHistory();
        setReadings(data);
        setLoading(false);
      } catch (err) {
        setError('Error al cargar el historial de lecturas');
        setLoading(false);
      }
    };

    fetchReadingHistory();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  };

  const getCardImagePath = (cardId) => {
    const cardNames = [
      "fool", "magician", "priestess", "empress", "emperor", 
      "hierophant", "lovers", "chariot", "strength", "hermit", 
      "wheel", "justice", "hanged", "death", "temperance", 
      "devil", "tower", "star", "moon", "sun", 
      "judgment", "world"
    ];
    
    // Card IDs are 1-22, but array is 0-indexed
    // Also, the Fool (ID 22) is traditionally numbered 0
    let index = cardId === 22 ? 0 : cardId - 1;
    
    return `/images/cards/${cardNames[index]}.png`;
  };

  return (
    <div className="history-page">
      <h1>Historial de Lecturas</h1>
      
      <button onClick={() => navigate('/')} className="back-button">
        Volver al Inicio
      </button>
      
      {loading && <p>Cargando historial...</p>}
      
      {error && <p className="error-message">{error}</p>}
      
      {!loading && readings.length === 0 && (
        <p>No tienes lecturas previas.</p>
      )}
      
      <div className="readings-list">
        {readings.map(reading => (
          <div key={reading.id} className="reading-item">
            <div className="reading-card">
              <img 
                src={getCardImagePath(reading.card_id)} 
                alt={`Card ${reading.card_id}`} 
                className="history-card-image" 
              />
            </div>
            <div className="reading-details">
              <p className="reading-date">{formatDate(reading.created_at)}</p>
              <h3>Pregunta:</h3>
              <p>{reading.question}</p>
              <h3>Interpretación:</h3>
              <p>{reading.message}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HistoryPage; 
